var map = {
	"./HEAD1.svg": 50251,
	"./HEAD10.svg": 12376,
	"./HEAD11.svg": 48513,
	"./HEAD12.svg": 42148,
	"./HEAD2.svg": 19748,
	"./HEAD3.svg": 90304,
	"./HEAD4.svg": 67460,
	"./HEAD5.svg": 27293,
	"./HEAD6.svg": 89610,
	"./HEAD7.svg": 98504,
	"./HEAD8.svg": 73660,
	"./HEAD9.svg": 36506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30794;